import {
    Component,
    EventEmitter,
    OnInit,
    OnDestroy,
    Input,
    Output,
} from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { Router } from "@angular/router";

import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

import { BrowserService } from "../../../shared/service/browser/browser.service";

import { foldDownUpAnimation } from "../../../shared/animations/fold.downUp.animation";
import { fadeInFadeOutAnimation } from "../../../shared/animations/fadeIn.fadeOut.animation";

import { ICities, ITrailing, IHeaderLink } from "./header.interface";

import { ISelectMolecule } from "../../../patterns/molecules/select/select.interface";

@Component({
    selector: "mlp-ng-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    animations: [foldDownUpAnimation, fadeInFadeOutAnimation],
})
export class HeaderSharedComponent implements OnInit, OnDestroy {
    @Input() hideSearch = false;

    @Input() loggedIn = false;
    @Input() showOldLogin = true;
    @Input() showNewLogin = false;

    @Output() login = new EventEmitter();
    @Output() logout = new EventEmitter();

    @Output() signUp = new EventEmitter();
    @Output() manage = new EventEmitter();

    @Input() logoUrl = "/assets/logo/pf_logo.svg";
    @Input() logoAlt = "Playfinder";

    @Input() phoneNumber: string;

    @Input() homeUrl = "/";

    @Input() trailing?: ITrailing;
    @Input() cities?: Observable<ICities>;

    @Input() links?: Array<IHeaderLink>;

    citySelectOptions: Array<ISelectMolecule>;
    form: FormGroup;

    get city(): FormControl {
        return this.form.get("city") as FormControl;
    }

    mobileNav = false;
    search = false;
    faderHeight = 0;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private browserService: BrowserService
    ) {
        this.form = this.formBuilder.group({ city: "" });

        this.city.valueChanges.pipe(filter((val) => !!val)).subscribe((val) => {
            if (val.data) {
                this.router.navigate(["/", val.data]);
            }
        });
    }

    ngOnInit(): void {
        if (this.cities) {
            this.cities.subscribe((cities) => {
                this.citySelectOptions = [
                    {
                        description: cities.currentCity,
                        data: null,
                    },
                ];

                cities.cities.forEach((city) => {
                    if (city.name !== cities.currentCity) {
                        this.citySelectOptions.push(<ISelectMolecule>{
                            description: city.name,
                            data: city.slug,
                        });
                    }
                });

                this.city.setValue(this.citySelectOptions[0]);
            });
        }
    }

    ngOnDestroy(): void {
        this.closeSearchMobileNav();
    }

    loginClick(): void {
        this.login.emit();
    }

    logoutClick(): void {
        this.logout.emit();
    }

    signUpClick(): void {
        this.signUp.emit();
    }
    
    manageClick(): void {
        this.manage.emit();
    }

    mobileNavToggle(): void {
        this.search = false;

        this.mobileNav = !this.mobileNav;

        if (this.browserService.isBrowser) {
            this.faderHeight = document.body.scrollHeight;
        }
    }

    searchToggle(e: Event): void {
        e.preventDefault();
        e.stopPropagation();
        this.mobileNav = false;

        this.search = !this.search;

        if (this.browserService.isBrowser) {
            this.faderHeight = document.body.scrollHeight;
        }
    }

    closeSearchMobileNav(): void {
        this.mobileNav = false;
        this.search = false;
    }
}
